import React, { useState } from "react";
import bzzCris from '../../images/gift/bzz-cris.svg'

const GiftSection = (props) => {


  const [isCopied, setIsCopied] = useState(false);  // Estado para el loader

  return (
    <section className={`section-padding`} id="gift">
      <div className="wpo-cta-section wpo-gift-section">
        <div className="conatiner-fluid">
          <div className="wpo-cta-item">
            <h2>¿Quieres hacernos un regalo?</h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="col-12 col-lg-6 mx-auto py-5" style={{
          textAlign: "center",
          margin: "20px 0",
          fontFamily: "'Roboto', sans-serif",
          padding: "20px",
          borderRadius: "10px",
          margin: "0 auto"
        }}>
          <p>Queremos empezar diciendo lo increíblemente agradecidos que estamos por teneros en nuestra boda. ¡Sois parte de nuestra historia y no podríamos estar más emocionados de compartir este momento con vosotros! ❤️</p>
          <p style={{ fontSize: "18px", textAlign: "center", marginBottom: "20px" }}>
            Nuestra luna de miel va a ser un viaje épico a Argentina y Brasil ✈️. Si queréis ayudarnos, cualquier contribución será muy bienvenida. 
          </p>
          <div style={{ marginBottom: "20px" }}>
            <h4 style={{ fontSize: "20px", marginBottom: "10px" }}>
              Transferencia bancaria 💳
            </h4>
            <p style={{ fontSize: "16px", marginBottom: "10px" }}>
              Número de cuenta: <strong>ES49 2100 0195 8602 0057 5620</strong>
            </p>
            {isCopied == false ?
              <button
                onClick={() => {
                  navigator.clipboard.writeText("ES49 2100 0195 8602 0057 5620");
                  setIsCopied(true);
                  setTimeout(() => {
                    setIsCopied(false);
                  }, 2000);
                }}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#15a5a7",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                  transition: "0.3s linear"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#0d7377"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#15a5a7"}
              >
                Copiar número de cuenta 📋
              </button>
              :
              <button
                style={{
                  padding: "10px 20px",
                  backgroundColor: "rgb(56 193 72)",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                  transition: "background-color 0.3s linear"
                }}
              >
                ¡Número copiado!
              </button>

            }
            <br /><br />
            <p>
            ¡Gracias por ser parte de nuestra aventura! 💕🎉
            </p>
          </div>

          {/* <div style={{ marginBottom: "20px" }}>
            <h4 style={{ fontSize: "20px", color: "#0d7377", marginBottom: "2rem" }}>
              Haz la transferencia directamente 🚀
            </h4>
            <a
              href="https://tu-banco.com/transferencia"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: "10px 20px",
                backgroundColor: "#15a5a7",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                textDecoration: "none",
                transition: "background-color 0.3s ease"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#0d7377"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#15a5a7"}
            >
              Ir a la transferencia bancaria 🌐
            </a>
          </div> */}

          <div>
            {/* <h4 style={{ fontSize: "20px", color: "#0d7377", marginBottom: "10px" }}>
              ¿Prefieres Bizum? 📲
            </h4>
            <p style={{ fontSize: "16px", color: "#0d7377", marginBottom: "10px" }}>
              Escanea este código QR o haz clic en el botón para enviarnos tu regalo.
            </p>
            <img
              src={bzzCris}
              alt="Código QR de Bizum"
              style={{ width: "150px", height: "150px", marginBottom: "10px" }}
            />
            <a
              href="bizum://send?phone=677601925"
              style={{
                padding: "10px 20px",
                backgroundColor: "#15a5a7",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                textDecoration: "none",
                transition: "background-color 0.3s ease"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#0d7377"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#15a5a7"}
            >
              Enviar con Bizum 💸
            </a> */}
          </div>
        </div>
      </div >
    </section >

  );
};

export default GiftSection;
